import React from 'react'
import DodoneContext from 'app/dodones/Context';
import { useContext, useState, useCallback } from "react"
import Modal from 'app/components/Modal'
import EditAttribute from 'app/dodones/edit/Attribute'

export default ({ children, attributeName }) => {
  const { dodone, updateDodone } = useContext(DodoneContext)
  const [isOpen, setIsOpen] = useState(false)
  const [value, setValue] = useState(dodone[attributeName])

  const attribute = dodone.constructor.getAttribute(attributeName);

  const open = useCallback(() => {
    setIsOpen(true)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
  }, [])

  const onChange = useCallback((newValue) => {
    setValue(newValue)
  }, [])

  const save = useCallback(() => {
    updateDodone.mutate({
      [attributeName]: value
    }, {
      onSettled: () => {
        close()
      }
    });
  })

  return <>
           <Modal isOpen={ isOpen } close={ close } header={ `Edit Dodone: ${attribute.humanName}` }>
             <div className="flex-1"></div>
             <EditAttribute onChange={ onChange } attribute={ attribute } value={ value } />
             <div className="flex-1"></div>
             <div className="btn btn-primary" onClick={ save }> Save </div>
           </Modal>
           <div onClick={ open }>
             { children }
           </div>
         </>
};
